import React, { FC, useState } from 'react';
import { partTypeEnum } from '../models/part-type.enum';
import { segmentType } from '../models/segment-type';
import styles from './HybridSegmentSelector.module.css';

export interface HybridSegmentSelectorProps {
    activeSegment: segmentType,
    setActiveSegment: (segmentType: segmentType) => void,
    getSegmentName: (segmentType: segmentType) => string,
}

const HybridSegmentSelector: FC<HybridSegmentSelectorProps> = ({ activeSegment, setActiveSegment, getSegmentName }) => {

    return (
        <div className={styles.HybridSegmentSelector} data-testid="HybridSegmentSelector">
            <div className={styles.amazing}>
                <button className={`${styles.spButton} ${styles.crownsegment}`} onClick={() => setActiveSegment(segmentType.crown)}>
                    <div className={styles.crownbox}>
                        <div className={`${styles.crownelement} ${activeSegment === segmentType.crown ? styles.active : ''}`}></div>
                    </div>
                    <div className={styles.labels}>
                        — {getSegmentName(segmentType.crown)}
                    </div>
                </button>
                <button className={`${styles.spButton} ${styles.middlesegment}`} onClick={() => setActiveSegment(segmentType.middle)}>
                    <div className={styles.middlebox}>
                        <div className={`${styles.middleelement} ${activeSegment === segmentType.middle ? styles.active : ''}`}></div>
                        <div className={`${styles.middleelement} ${activeSegment === segmentType.middle ? styles.active : ''}`}></div>
                    </div>
                    <div className={styles.labels}>
                        — {getSegmentName(segmentType.middle)}
                    </div>
                </button>
                <button className={`${styles.spButton} ${styles.plinthsegment}`} onClick={() => setActiveSegment(segmentType.plinth)}>
                    <div className={styles.plinthbox}>
                        <div className={`${styles.plinthelement} ${activeSegment === segmentType.plinth ? styles.active : ''}`}></div>
                    </div>
                    <div className={styles.labels}>
                        — {getSegmentName(segmentType.plinth)}
                    </div>
                </button>
            </div>
        </div>
    )
};

export default HybridSegmentSelector;
